export default {
    methods: {
        
        /**
         * track event for google analytics
         */
        trackGAEvent: function(category, action, label) {
            // gtag
            if (typeof(gtag) !== 'undefined') {
                gtag('event', action, {
                  'event_category': category,
                  'event_label': label,
                });
            } else {
                console.log('GA tracking 2', category, action, label); 
            }
        },

    },
}